export default __webpack_public_path__ + "static/video-banner-medium-4562a497f593d5ad476fd8296b72ae6d.jpg";